import { Card, Tabs, Table, Row, Col, Tag, Form, Tooltip, Input, Button, Dropdown, Menu, Upload, Steps, Modal, Skeleton, Select, Image, Space, List, Divider, InputNumber, DatePicker, Carousel } from "antd";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import React, { useEffect, useState, useCallback, useRef } from "react";
// import Clock from 'react-live-clock';
import { formatCurrency } from '../common/Format'
import {
    MenuOutlined, SettingOutlined, DeleteOutlined, FormOutlined, FileTextOutlined, PlusOutlined, UserOutlined, CloseOutlined, CheckOutlined
} from "@ant-design/icons";
import swal from "sweetalert";

import 'moment/locale/vi';
import ButtonGroup from "antd/lib/button/button-group";
import moment from "moment";
import axiosClient from "../../api/axios";
import LinkUpload from "../../api/LinkUpload";



const { Step } = Steps;
const { TabPane } = Tabs;
const { Option } = Select;
const MenuAdmin = () => {
    const [progress, setProgress] = useState(0);
    const editorRef = useRef(null);
    const [inputValueUrl, setInputValueURL] = useState({
        CategoryName: '',
        SlugName: ''
    })
    const [value, setValue] = useState('');
    const [text, setText] = useState('');
    const database = localStorage.getItem('DatabaseName');
    const token = localStorage.getItem('token');
    const [Menu, setMenu] = useState({})
    const IDAccount = localStorage.getItem('ID');
    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const user = {
        "ID": localStorage.getItem('ID'),
        "Role": localStorage.getItem('Role'),
        "UserName": localStorage.getItem('UserName'),
        "FullName": localStorage.getItem('FullName'),
        "Password": localStorage.getItem('Password'),
        "Phone": localStorage.getItem('Phone'),
        "Email": localStorage.getItem('Email'),
        "Image": localStorage.getItem('Image'),
        "Active": true,
        "DatabaseName": localStorage.getItem('DatabaseName'),
        "SecurityCode": localStorage.getItem('SecurityCode'),
        "ExpirationDate": localStorage.getItem('ExpirationDate')
    }
    const [dataAccount, setDataAccount] = useState([])
    const [formMenu] = Form.useForm();
    const [formFilterMenu] = Form.useForm()



    // Quản lý thông tin Danh mục
    const [dataMenu, setDataMenu] = useState([]);
    const [openModalMenu, setOpenModalMenu] = useState(false);
    const [loadingMenu, setLoadingMenu] = useState(false);
    const [statusMenu, setStatusMenu] = useState(false);


    // upload image
    const [currentIDMenu, setCurrentIDMenu] = useState(0)
    const [fileListMenu, setFileListMenu] = useState([]);
    const [previewImageMenu, setPreviewImageMenu] = useState('')
    const changeUploadMenu = async ({ fileList }) => {
        const dataImage = fileList.map(r => `/Uploads/${database}/` + currentIDMenu + '/' + r.name);
        setFileListMenu(fileList);
        formMenu.setFieldsValue({
            ImageUrl: dataImage[0]
        })

    };
    const previewUploadMenu = async (file) => {
        const resultUrl = file.name;
        setPreviewImageMenu(resultUrl);
    };

    const uploadImage = async options => {
        const { onSuccess, onError, file, onProgress } = options;
        const fmData = new FormData();
        const config = {
            headers: {
                "content-type": "multipart/form-data",
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            onUploadProgress: event => {
                const percent = Math.floor((event.loaded / event.total) * 100);
                setProgress(percent);
                if (percent === 100) {
                    setTimeout(() => setProgress(0), 1000);
                }
                onProgress({ percent: (event.loaded / event.total) * 100 });
            }
        };

        const filenew = new File([file], file.name, {
            type: 'image/png'
        });
        fmData.append("image", filenew);
        try {

            const res = await axiosClient.post(
                `/uploadfile?subDirectory=${currentIDMenu}`,
                fmData,
                config
            );
            onSuccess("Ok");
            console.log("server res: ", res);
            if (res.status === 200) {
                //const pathImage = String(res.data.FilePath).replace('/uploads/', '');
                setProgress(0)

            }

        } catch (err) {
            console.log("Eroor: ", err);
            const error = new Error("Some error");
            onError({ err });
        }

    };
    const selectCategory = (value) => {
        const cat = dataCategory.find(item => item.ID === value);
        if (!cat) return;                 // không tìm thấy category, thoát sớm
        // 1) Lưu Slug vào state
        setInputValueURL(prev => ({ ...prev, CategoryName: cat.Slug }));
        // 2) Xác định URL
        const directSlugIds = [6, 25];    // list ID cần URL dạng '/slug'
        const url = directSlugIds.includes(value)
            ? `/${cat.Slug}`
            : `/category/${cat.Slug}`;

        // 3) Set vào form
        formMenu.setFieldsValue({ Url: url });
    };
    const selectArticle = (value) => {
        const cat = dataArticles.find(item => item.ID === value);
        if (!cat) {
            formMenu.setFieldsValue({ Url: '' });
        }
        else {
            const url = `/view/${cat.Slug}`
            formMenu.setFieldsValue({ Url: url });
        }
    };

    // Hàm xử lý khi thay đổi Slug
    const handleChangeSlug = (e) => {
        const value = e.target.value;
        setInputValueURL(prevState => {
            let newState = { ...prevState };
            newState.SlugName = value;
            return newState;
        });
    };
    const getSlug = (url) => {
        if (!url) return '';
        // '/category/san-pham' → ['category','san-pham'] → 'san-pham'
        // '/gioi-thieu'        → ['gioi-thieu']         → 'gioi-thieu'
        const parts = url.split('/').filter(Boolean);
        return parts[parts.length - 1] || '';
    };
    const showModalMenu = (record) => {
        //const IDTemp = 0;
        formMenu.resetFields();
        if (typeof record === 'object') {
            setLoadingMenu(false)
            setStatusMenu(true)
            const slug = getSlug(record.Url);          // 'san-pham' ...
            const found = dataCategory.find(c => c.Slug === slug);


            formMenu.setFieldsValue(
                {
                    "ID": record.ID,
                    "IDParent": record.IDParent === 0 ? null : record.IDParent,
                    "Title": record.Title,
                    "Slug": record.Slug,
                    "Url": record.Url,
                    "Position": record.Position,
                    "Active": record.Active,
                    IDCategory:
                        (
                            dataCategory.find(item =>
                                String(item.Slug).includes(
                                    String(record.Url)
                                        .split(
                                            String(record.Slug).includes('thanh-vien')
                                            || String(item.Slug).includes(
                                                String(record.Url)
                                                    .split(
                                                        String(record.Slug).includes('to-chuc-hanh-nghe-luat-su') ? '/' : '/category/'
                                                    )
                                                    .filter(Boolean)[0]
                                            )
                                        )
                                )
                            ) || {}   // bảo vệ null
                        ).ID || ''
                }
            );
            setOpenModalMenu(true)
        }
        else {
            setLoadingMenu(false)
            setStatusMenu(false)
            formMenu.setFieldsValue({
                "ID": 1,
                "IDParent": null,
                "Title": "",
                "Slug": "",
                "Url": "",
                "Position": 1,
                "Active": true
            })
            setOpenModalMenu(true)
        }


    }

    const onFinishMenu = (values) => {

        setLoadingMenu(true)
        if (statusMenu === false) {
            axiosClient.post('/Menus/AddMenus', values, {
                headers: header
            }).then(res => {
                setLoadingMenu(false)
                swal('Thành công!', {
                    icon: 'success'
                })
                formMenu.resetFields();
                LoadDataMenu();
                setOpenModalMenu(false)
            })
        }
        else {

            axiosClient.post('/Menus/UpdateMenus', values, {
                headers: header
            }).then(res => {
                if (res.status === 200) {
                    setLoadingMenu(false)
                    swal('Thành công!', {
                        icon: 'success'
                    })
                    formMenu.resetFields();
                    LoadDataMenu();
                    setOpenModalMenu(false)
                }
            })
        }

    }


    const LoadDataMenu = () => {
        axiosClient.post('/Menus/GetMenusAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataMenu(res.data);
            }
        })
    }

    const [dataPermission, setDataPermission] = useState([]);
    const LoadDataPermission = () => {
        axiosClient.post('/Permissions/GetApiPermissionAll', '', { headers: header }).then(resPermiss => {
            setDataPermission(resPermiss.data);
        })
    }

    const renderMenu = () => {
        return (
            <Form
                id="form-Menu"
                form={formMenu}
                onFinish={onFinishMenu}
                colon={false}
                name="basic"
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 18,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name='ID'>
                    <Input />
                </Form.Item>
                <Form.Item name='IDParent' label='Thuộc tính'>
                    <Select>
                        <Option value={null}>Menu chính</Option>
                        {dataMenu.filter(i => i.IDParent === 0).map(r => (
                            <Option value={r.ID}>{r.Title}</Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: 'Nhập tên menu',
                    },
                ]} name='Title' label='Tên Menu'>
                    <Input />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: false,
                        message: 'Chọn danh mục',
                    },
                ]} label='Danh mục' name={'IDCategory'}>
                    <Select showSearch filterOption={(input, option) =>
                        option?.children.toLowerCase().includes(input.toLowerCase())
                    } onSelect={selectCategory}>
                        {dataCategory.map(r => (
                            <Option value={r.ID}>{r.Name}</Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: false,
                        message: 'Chọn bài viết',
                    },
                ]} label='Bài viết' name={'IDArticle'}>
                    <Select
                        showSearch
                        onSelect={selectArticle}
                        filterOption={(input, option) =>
                            option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                        style={{ width: '100%' }}
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={{ maxWidth: 500 }}
                        dropdownClassName="article-select-dropdown"
                        optionLabelProp="label" // 👈 để label chính là thứ filter & hiển thị
                    >
                        <Option value={0} label="Không">
                            <div style={{ whiteSpace: 'normal' }}>Không</div>
                        </Option>

                        {dataArticles.map((r) => (
                            <Option key={r.ID} value={r.ID} label={r.Title}>
                                <Tooltip title={r.Title}>
                                    <div
                                        style={{
                                            whiteSpace: 'normal',
                                            wordWrap: 'break-word',
                                            maxWidth: '480px',
                                        }}
                                    >
                                        {r.Title}
                                    </div>
                                </Tooltip>
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item hidden rules={[
                    {
                        required: false,
                        message: 'Nhập tên Slug',
                    },
                ]} label='Slug' name={'Slug'}>
                    <Input />
                </Form.Item>
                <Form.Item name={'Url'} label='Url'>
                    <Input disabled />
                </Form.Item>
                <Form.Item name='Position' label='Vị trí'>
                    <InputNumber min={0} />
                </Form.Item>
                <Form.Item name='Active' label='Trạng thái'>
                    <Select>
                        <Option value={true}>Hiển thị</Option>
                        <Option value={false}>Hủy</Option>
                    </Select>
                </Form.Item>
            </Form >
        )
    }
    const onDeleteMenu = (id) => {
        if (id !== 0) {
            swal({
                title: "Bạn có muốn xóa menu này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`Menus/DeleteMenus/${id}`, id, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                LoadDataMenu()
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const changePositionMenu = (record, value) => {
        axiosClient.post('/Menus/UpdateMenus', {
            "ID": record.ID,
            "IDParent": record.IDParent,
            "Title": record.Title,
            "Slug": record.Slug,
            "Url": record.Url,
            "Position": value,
            "Active": record.Active
        }, { headers: header }).then(res => {
            if (res.status === 200) {
                LoadDataMenu()
            }

        })

    }
    const columnMenu = [
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Tên
                </div>
            ),
            dataIndex: 'Name',
            width: 250,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontWeight: 500 }}>
                        {String(record.Title).toUpperCase()}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Thuộc tính
                </div>
            ),
            dataIndex: 'Name',
            width: 150,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {record.IDParent === 0 ? <Tag color="#108ee9">Menu chính</Tag> : <Tag color="#87d068">{dataMenu.filter(i => i.ID === record.IDParent).map(r => r.Title)}</Tag>}
                    </div>
                );
            },
        },
        // {
        //     title: (
        //         <div style={{ textAlign: "center" }}>
        //             Slug
        //         </div>
        //     ),
        //     dataIndex: 'Phone',
        //     width: 150,
        //     render: (text, record) => {
        //         return (
        //             <div style={{ textAlign: "center" }}>
        //                 {record.Slug}
        //             </div>
        //         );
        //     },
        // },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Url
                </div>
            ),
            dataIndex: 'Phone',
            width: 250,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left" }}>
                        {record.Url}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Thứ tự
                </div>
            ),
            dataIndex: 'Phone',
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <InputNumber onChange={(e) => changePositionMenu(record, e)} min={0} defaultValue={record.Position} />
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Hiển thị
                </div>
            ),
            dataIndex: 'Phone',
            width: 80,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {record.Active === true ? <CheckOutlined style={{ color: '#339933', fontSize: 18 }} /> : <CloseOutlined style={{ color: '#f50', fontSize: 18 }} />}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    <SettingOutlined />
                </div>
            ),
            width: 80,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <ButtonGroup>
                            <Button disabled={dataPermission.includes('UpdateMenus') ? false : true} icon={<FormOutlined style={{ color: "#33CCFF" }} />} onClick={(e) => showModalMenu(record)}  ></Button>
                            &ensp;
                            <Button
                                disabled={dataPermission.includes('DeleteMenus') ? false : true}
                                onClick={(e) => {
                                    onDeleteMenu(record.ID, e);
                                }}
                                icon={<DeleteOutlined style={{ color: "red" }} />}
                            ></Button>
                        </ButtonGroup>
                    </div>
                );
            },
        },
    ]
    const changeCategory = (value, child) => {
        setCurrentIDMenu(Number(child.key))
        formMenu.setFieldsValue({
            IDCategory: Number(child.key)
        })
    }

    const LoadDataAccount = () => {
        axiosClient.post('/Accounts/SubGetAccountsAll', user, {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataAccount(res.data);

            }
        })
    }
    const [dataCategory, setDataCategory] = useState([])
    const LoadDataCategory = () => {
        axiosClient.post('/Categories/GetCategoriesAll', '', {
            headers: header
        }).then(resCate => {
            setDataCategory(resCate.data)
        })
    }

    const [dataArticles, setDataArticles] = useState([])
    const LoadDataArticles = () => {
        axiosClient.post('/Articles/GetArticlesAll', '', {
            headers: header
        }).then(res => {
            setDataArticles(res.data)
        })
    }
    useEffect(() => {
        LoadDataArticles()
        LoadDataCategory()
        LoadDataPermission()
        LoadDataMenu();
        LoadDataAccount()
    }, [])


    const handleCancelMenu = () => {
        setLoadingMenu(false);
        setOpenModalMenu(false);
    }
    const handleOkMenu = () => {
        setTimeout(() => {
            setLoadingMenu(false);
            setOpenModalMenu(false);
        }, 3000);
    }

    const isObjectEmpty = (object) => {
        return Object.keys(object).length === 0
    }


    return (
        <div>
            <Card size="small">
                <Tabs type="card"
                    tabBarGutter={10}
                    tabPosition="top" // Hiển thị tabs theo chiều ngang
                    tabBarStyle={{ backgroundColor: "#D6E4FF", borderRadius: "8px", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)" }}
                    moreIcon={null} >

                    <TabPane tab="Menu header (phía trên)" key="1">
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form id="form-filter-Menu" form={formFilterMenu}>
                                    <Row gutter={[8, 8]}>
                                        <Col xs={24} xl={24} span={4}>
                                            <Button hidden={dataPermission.includes('AddMenus') ? false : true} key={1} onClick={(e) => showModalMenu(0, e)} style={{ backgroundColor: '#00CC99', color: 'white', minWidth: 100, borderRadius: 5 }} icon={<PlusOutlined style={{ color: 'white' }} />}>
                                                Thêm mới
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                            <Col span={24}>
                                <br />
                            </Col>
                            <Col xs={24} xl={24} span={24}>
                                <Table rowClassName={(record, index) => {
                                    return index % 2 === 0 ? "gray-color" : "";
                                }} scroll={{ x: 1000 }} size="middle" dataSource={dataMenu} pagination={{ pageSize: 10 }} sticky columns={columnMenu} />
                            </Col>
                        </Row>
                    </TabPane>


                </Tabs>
            </Card>

            <Modal
                width={600}
                onOk={handleOkMenu}
                onCancel={handleCancelMenu}
                open={openModalMenu}
                title={
                    <span>
                        {statusMenu === false ? 'Thêm mới menu' : 'Cập nhật menu'}
                    </span>
                }
                footer={[
                    <Button onClick={handleCancelMenu} key="back" >
                        Hủy
                    </Button>,
                    <Button form="form-Menu" type="primary" htmlType="submit" loading={loadingMenu}>
                        Lưu
                    </Button>,
                ]}
            >
                {loadingMenu ? (
                    <>
                        <Skeleton loading={loadingMenu} active />
                    </>
                ) : (
                    <>{renderMenu()}</>
                )}
            </Modal>

        </div >
    )

}
export default MenuAdmin;